<nav class="site-header navbar navbar-expand-lg navbar-dark sticky-top">
  <div class="container">
    <!-- Brand -->
    <a class="navbar-brand fw-bold" routerLink="/" aria-label="Alphatec Scientific">
      <img src="assets/logo/logo-alp.png" alt="Alphatec Scientific" class="brand-img">
    </a>

    <!-- Toggler -->
    <button class="navbar-toggler shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav"
      aria-controls="mainNav" aria-expanded="false" aria-label="Alternar navegación">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Nav + CTA -->
    <div id="mainNav" class="collapse navbar-collapse flex-lg-grow-1">
      <!-- MENU CENTRADO -->
      <ul class="navbar-nav nav-center mb-2 mb-lg-0 align-items-lg-center">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            Inicio
          </a>
        </li>

        <!-- Mega menú Productos -->
       <!-- ... -->
<li class="nav-item dropdown position-static">
  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
    Productos
  </a>

  <!-- CENTRADO -->
  <div class="dropdown-menu mega mega--center p-0">
    <div class="mega__inner container py-3">
      <div class="row g-2">
        <div class="col-6 col-md-3" *ngFor="let c of cats">
          <a class="mega-item" [routerLink]="['/categoria', c.slug]">
            <img *ngIf="c.iconUrl" [src]="c.iconUrl" class="icon me-2" alt="">
            <span>{{ c.name }}</span>
          </a>
        </div>
      </div>
      <div class="text-center mt-3">
        <a class="btn btn-sm btn-outline-light" routerLink="/tienda">Ver todas las categorías</a>
      </div>
    </div>
  </div>
</li>
<!-- ... -->


        <!-- Software -->
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
            Software
          </a>
          <ul class="dropdown-menu dropdown-menu-dark shadow-lg text-center">
            <li><a class="dropdown-item" routerLink="/software/lis">LIS Clínico</a></li>
            <li><a class="dropdown-item" routerLink="/software/blood-bank">Banco de Sangre</a></li>
            <li><a class="dropdown-item" routerLink="/software/vet-lis">Vet LIS</a></li>
          </ul>
        </li>

        <li class="nav-item"><a class="nav-link" routerLink="/nosotros" routerLinkActive="active">Nosotros</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/contacto" routerLinkActive="active">Contacto</a></li>
      </ul>

      <!-- CTA / Carrito (derecha) -->
      <div class="header-cta d-flex align-items-center gap-2 ms-lg-3">
        <a class="btn btn-quote" routerLink="/cotizar">
          Cotizar
        </a>

        <a class="btn btn-cart position-relative" routerLink="/cart" aria-label="Carrito">
          <i class="bi bi-cart"></i>
          <span *ngIf="cart.count() > 0"
                class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger cart-badge">
            {{ cart.count() }}
          </span>
        </a>
      </div>
    </div>
  </div>
</nav>
